import React from "react"

const YoutubeVideo = props => {
  if (!props.url) {
    return ""
  }

  return (
    <div className="youtube-video">
      <iframe
        src={props.url}
        title={props.url}
      ></iframe>
    </div>
  )
}

export default YoutubeVideo
